import {Controller, useFormContext} from "react-hook-form";
import {AccountDetailsFormValues} from "../types";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Select, Space, Spin} from "antd";
import {useGetPayoutCountries} from "../../../../../../../react-query-hooks/payout";
import {usePayoutSettingsContext} from "../../context";

export function AccountDetailsFormCountryFormField({
  isVerifyingAccountNumber,
  isMutationIdle,
  resetMutation,
}: {
  isVerifyingAccountNumber: boolean;
  isMutationIdle: boolean;
  resetMutation: () => void;
}) {
  const getPayoutCountriesQuery = useGetPayoutCountries();
  const {dispatch} = usePayoutSettingsContext();
  const {control, setValue} = useFormContext<AccountDetailsFormValues>();

  const handleCountrySelectChange = (
    value: string,
    onChange: (...event: any[]) => void
  ) => {
    if (!isMutationIdle) {
      resetMutation();
    }
    onChange(value);
    dispatch({
      type: "update-selected-country-code",
      payload: value,
    });
    dispatch({
      type: "reset-payout-banks-state",
    });
    setValue("accountNumber", "");
    setValue("bankCode", "");
    setValue("branchCode", "");
  };

  return (
    <div>
      <FormField
        id="accountCountry"
        label="Country"
        renderInput={(id) => (
          <Controller
            control={control}
            name="countryCode"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={(value) => handleCountrySelectChange(value, onChange)}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  showSearch
                  options={
                    getPayoutCountriesQuery.isLoading
                      ? []
                      : getPayoutCountriesQuery.isError
                      ? []
                      : getPayoutCountriesQuery.data.data.countries.map((country) => {
                          return {label: country.name, value: country.code};
                        })
                  }
                  placeholder="Please select"
                  loading={
                    getPayoutCountriesQuery.isFetching ||
                    getPayoutCountriesQuery.isLoading
                  }
                  disabled={
                    getPayoutCountriesQuery.isLoading ||
                    getPayoutCountriesQuery.isFetching ||
                    getPayoutCountriesQuery.isError ||
                    isVerifyingAccountNumber
                  }
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option) {
                      return option.label.toLowerCase().includes(input.toLowerCase());
                    } else {
                      return false;
                    }
                  }}
                  notFoundContent={
                    getPayoutCountriesQuery.isLoading ||
                    getPayoutCountriesQuery.isFetching ? (
                      <Spin />
                    ) : null
                  }
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
